import {Types} from './actions';
import initialState from './initialState';
import ReducerBuilder from "classes/ReducerBuilder";

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.SUBMIT_CREATE_PRIZE)
    .reduce((state, action) => {
      state.createPrizeFormSubmitted = true;
    })
    .forType(Types.CREATE_PRIZE_COMPLETE)
    .reduce((state, {prizeId}) => {
      state.createPrizeFormSubmitted = false;
      state.creatingPrize = false;
      state.error = null;

      state.createdPrizeId = prizeId;
    })
    .forType(Types.START_CREATE_PRIZE)
    .reduce((state, action) => {
      state.creatingPrize = true;
      state.createdPrizeId = null;
    })
    .forType(Types.END_CREATE_PRIZE)
    .reduce((state, action) => {
      state.creatingPrize = false;
      state.createdPrizeId = null;
      state.error = null;
    })
    .forType(Types.ERROR_CREATING_PRIZE)
    .reduce((state, action) => {
      state.error = action.error;
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/pages/PrizeCreator/reducer.js